import { render, staticRenderFns } from "./style-one.vue?vue&type=template&id=a572d3b0&scoped=true&"
import script from "./style-one.vue?vue&type=script&lang=js&"
export * from "./style-one.vue?vue&type=script&lang=js&"
import style0 from "./style-one.vue?vue&type=style&index=0&id=a572d3b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a572d3b0",
  null
  
)

export default component.exports